var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sensor-state-wrap"},[_c('span',{staticClass:"iconfont",class:_vm.option.ico,style:({ color: _vm.option.color })}),_c('span',[_vm._v(_vm._s(_vm.option.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }